import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { CourtService } from 'src/app/service/common/court.service';
import { MessageService } from 'src/app/service/common/message.service';
import { MeetingModalComponent } from '../meeting-modal/meeting-modal.component';

@Component({
  selector: 'app-court',
  templateUrl: './court.component.html',
  styleUrls: ['./court.component.css']
})
export class CourtComponent implements OnInit {

  private _subs: Subscription = new Subscription();
  court : {
    'id' : string, 
    'courtName' : string,
    'address' : string, 
    'postcode' : string,
    'email' : string,
    'telephone' : string, 
    'fax' : string,
    'note' : string, 
    'active' : string
  };

  constructor(
    private msgService : MessageService,
    private courtService : CourtService,
    @Inject(MAT_DIALOG_DATA) public data : any,
    private dialogRef : MatDialogRef<MeetingModalComponent>,
  ) {
    this.court = {
      'id' : '', 
      'courtName' : '',
      'address' : '', 
      'postcode' : '',
      'email' : '',
      'telephone' : '', 
      'fax' : '',
      'note' : '', 
      'active' : ''
    } 
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    if(this.data.id){
      this.courtService.getCourt(this.data.id).subscribe(res=>{
        this.court = res.data;
      })
    }
  }

  saveCourtData(courtData){
    if(this.data.id){
      this.updateCourt(this.data.id, courtData);
    }else{
      this.saveCourt(courtData);
    }
  }

  updateCourt(id, courtData){
    this._subs.add(
      this.courtService.updateCourt(id, courtData).subscribe(res=>{
        console.log(res);
        if(res.status == 'ok'){
          this.dialogRef.close(res);
          this.msgService.success(res.message);
        }else{
          this.msgService.error(res.message);
        }
      })
    )
  }

  saveCourt(courtData){
    this._subs.add(
      this.courtService.saveCourt(courtData).subscribe(res=>{
        console.log(res);
        if(res.status == 'ok'){
          this.dialogRef.close(res);
          this.msgService.success(res.message);
        }else{
          this.msgService.error(res.message);
        }
      })
    )
  }

  closeModal(){
    this.dialogRef.close(null);
  }

  ngOnDestroy(){
    this._subs.unsubscribe();
  }

}
